module.exports = __webpack_public_path__ + "static/img/certification.65a2551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/certification.png
// module id = 6zRQ
// module chunks = 1